import React, { useState, useEffect } from 'react';
import './styles.css';  // Import the CSS file from the same directory

function SibCalculator() {
  const [ndauSent, setNdauSent] = useState('');
  const [sib, setSib] = useState('');
  const [recipientBalance, setRecipientBalance] = useState('');

  useEffect(() => {
    const fetchSibValue = async () => {
      try {
        const response = await fetch('https://mainnet-3.ndau.tech:3030/price/current');
        const data = await response.json();
        if (data.sib) {
          const formattedSib = (data.sib / 10000000000).toFixed(2);  // Ensure consistency in decimal places
          setSib(formattedSib);
        }
      } catch (error) {
        console.error('Failed to fetch SIB:', error);
      }
    };
    fetchSibValue();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const E = parseFloat(sib) / 100;
    const calculatedBalance = parseFloat(ndauSent.replace(/,/g, '')) / (E + 1);
    setRecipientBalance(calculatedBalance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}));
  };

  return (
    <div className="calculator">
      <h1>SIB Calculator</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="ndau_sent">NDAU Sent:</label>
          <input
            type="text"
            id="ndau_sent"
            value={ndauSent}
            onChange={e => setNdauSent(e.target.value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','))}
            required
          />
        </div>
        <div>
          <label htmlFor="sib">Current SIB %:</label>
          <input
            type="text"
            id="sib"
            value={sib}
            onChange={e => setSib(e.target.value)}
            required
          />
        </div>
        <button type="submit">Calculate</button>
      </form>
      {recipientBalance && <div className="data-item"><span>Result:</span> <span className="value">{recipientBalance}</span></div>}
    </div>
  );
}

export default SibCalculator;
